import Image from './image';

export default Image;
export type * from './types';
